import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAppSelector } from '@/app/store/hooks';
import { ROUTES } from '@/app/router/route-constants';
import { selectIsBackofficeAuthenticated } from '@/features/backoffice2020/store/backoffice-auth-slice';

/**
 * Protects backoffice routes. Redirects to /backoffice/login when unauthenticated.
 */
export function BackofficeAuthGuard() {
  const isAuthenticated = useAppSelector(selectIsBackofficeAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to={ROUTES.BACKOFFICE_LOGIN}
        state={{ from: location }}
        replace
      />
    );
  }

  return <Outlet />;
}
